(function () {
	
	const initSlider = () => {
		let productSlider;
		const productSliders = document.querySelectorAll('.collection-hero__collection-options');

		productSliders.forEach((slider, index) => {
			productSlider = new Swiper(slider, {
				navigation: {
					nextEl: ".collection-list-carousel__button-next",
					prevEl: ".collection-list-carousel__button-prev",
				},
                slidesPerView: 5,
                slidesPerGroup: 1,
                spaceBetween: 8,
				on: {
					init: function() {
						setTimeout(() => {
							equalizeSlideHeights(this.el);
						}, 100);
					},
					resize: function() {
						setTimeout(() => {
							equalizeSlideHeights(this.el);
						}, 100);
					},
					slideChange: function() {
						setTimeout(() => {
							equalizeSlideHeights(this.el);
						}, 50);
					}
				},
                breakpoints: {
                    768: {
                      slidesPerView: 7,
                    },
                    1024: {
                      slidesPerView: 5,
                    }
                  }
			});
		});
	};

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.collection-hero__collection-options');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.product-slider-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
			setTimeout(() => {
				equalizeAllSliders();
			}, 150);
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	function equalizeSlideHeights(sliderElement = null) {
		const selector = sliderElement 
			? sliderElement.querySelectorAll('.swiper-slide')
			: document.querySelectorAll('.collection-hero__collection-options .swiper-slide');
		
		const slides = Array.from(selector);
		
		if (slides.length === 0) return;
		
		let maxHeight = 0;
		
		slides.forEach(slide => {
			slide.style.height = 'auto';
		});
		
		slides.forEach(slide => {
			const slideHeight = slide.offsetHeight;
			if (slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});
		
		slides.forEach(slide => {
			slide.style.height = maxHeight + 'px';
		});
	}

	function equalizeAllSliders() {
		const productSliders = document.querySelectorAll('.collection-hero__collection-options');
		productSliders.forEach(slider => {
			equalizeSlideHeights(slider);
		});
	}

	function waitForContentAndEqualize() {
		const images = document.querySelectorAll('.collection-hero__collection-options img');
		let loadedImages = 0;
		
		if (images.length === 0) {
			equalizeAllSliders();
			return;
		}
		
		images.forEach(img => {
			if (img.complete) {
				loadedImages++;
			} else {
				img.onload = () => {
					loadedImages++;
					if (loadedImages === images.length) {
						equalizeAllSliders();
					}
				};
				img.onerror = () => {
					loadedImages++;
					if (loadedImages === images.length) {
						equalizeAllSliders();
					}
				};
			}
		});
		
		if (loadedImages === images.length) {
			equalizeAllSliders();
		}
	}

	initSection();

	document.addEventListener('DOMContentLoaded', () => {
		waitForContentAndEqualize();
	});

	window.addEventListener('resize', () => {
		setTimeout(equalizeAllSliders, 200);
	});

	document.addEventListener('shopify:section:load', function () {
		initSection();
		setTimeout(() => {
			waitForContentAndEqualize();
		}, 200);
	});

	if (typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver((mutations) => {
			let shouldEqualize = false;
			
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					mutation.addedNodes.forEach(node => {
						if (node.nodeType === 1 && 
							(node.classList?.contains('swiper-slide') || 
							 node.querySelector?.('.swiper-slide'))) {
							shouldEqualize = true;
						}
					});
				}
			});
			
			if (shouldEqualize) {
				setTimeout(equalizeAllSliders, 100);
			}
		});
		
		const sliderContainers = document.querySelectorAll('.collection-hero__collection-options');
		sliderContainers.forEach(container => {
			observer.observe(container, { childList: true, subtree: true });
		});
	}

})();